import React from 'react';
import styled from '@emotion/styled';
import { Card, Divider, Heading } from '../../common';
import Accordion from '../../common/Accordion';
import drag from '../../images/drag.svg';
import deleteImg from '../../images/delete.svg';
import { useDispatch } from 'react-redux';

const LeftSideContainer = styled(Card)`
  background: var(--midWhite);
  padding: 0;
  border-radius: 5px;
  height: ${props => (props.fullScreen ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
`;
const ScrollContainer = styled.div`
  height: ${props => (props.fullScreen ? 'auto' : props.compact ? '14rem' : '30.5rem')};
  flex: ${props => (props.fullScreen || props.compact ? '1 1 auto' : 'none')};
  min-height: 0;
  overflow-y: scroll;
`;

export default function CaptureGuide({
  preEditorData = {},
  setPreEditorData = () => {},
  onClipClick = () => {},
  getUpdatedPreEditorData = () => {},
  userId,
  projectId,
  projectRespondentId,
  onAfterDelete,
  activeClipId = null,
  sourceFile = '',
  fullScreen = false,
  asColumn = true,
  compact = false
}) {
  const dispatch = useDispatch();

  const handleDelete = (e, clip_ID, question_ID, index, clipIndex) => {
    e.stopPropagation();
    const updated = { ...(preEditorData || {}) };
    if (updated.CaptureGuide && updated.CaptureGuide[index]?.clip_array) {
      updated.CaptureGuide[index].clip_array[clipIndex].buttonName = '';
      setPreEditorData(updated);
    }
    dispatch({ type: 'REQUEST_DELETEVIDEOCLIP', payload: { user_ID: userId, clip_ID: clip_ID, quest_ID: question_ID } });
    setTimeout(() => {
      getUpdatedPreEditorData();
      if (typeof onAfterDelete === 'function') onAfterDelete();
    }, 500);
  };

  const content = (
      <LeftSideContainer fullScreen={fullScreen}>
        <Heading
          type={3}
          className="p-3 mb-0 pb-0"
          fontSize="10px"
          fontWeight="400"
          color="var(--seaBlue)"
          style={{ lineHeight: '14px', letterSpacing: '0.15rem', textTransform: 'uppercase' }}
        >
          capture guide
        </Heading>
        <Divider background="var(--lightGrey)" height="2px" width="100%" margin="0" />
        <ScrollContainer fullScreen={fullScreen} compact={compact}>
          {preEditorData &&
            preEditorData.CaptureGuide &&
            preEditorData.CaptureGuide.map((data, index) => (
              <React.Fragment key={index}>
                <Accordion className=" py-2 px-2" title={data.sectionName}>
                  <ul>
                    {data.clip_array &&
                      data.clip_array.map((value, clipIndex) => (
                        <div
                          key={value.clip_ID || clipIndex}
                          className="d-flex align-items-center accordion_item_container"
                          onClick={() => onClipClick(value.startTime, value.endTime, value, index, data, clipIndex)}
                          id={value.clip_ID}
                        >
                          <div className="pl-2" style={{ width: '10%' }}>
                            <img src={drag} alt="drag" />
                          </div>
                          <li className="accordion_item" style={{ width: '80%' }}>
                            <div className="title" style={{ fontWeight: activeClipId === value.clip_ID ? 'bold' : 'normal' }}>{value.buttonName}</div>
                            <div className="time">{(value.startTime || '').split(' ')[1]}</div>
                          </li>
                          {sourceFile !== 'TranscriptComponent' && (
                            <div style={{ width: '10%' }}>
                              <img
                                src={deleteImg}
                                alt="delete"
                                onClick={e => handleDelete(e, value.clip_ID, value.question_ID, index, clipIndex)}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                  </ul>
                </Accordion>
                <Divider background="var(--lightGrey)" height="2px" width="100%" margin="0" />
              </React.Fragment>
            ))}
        </ScrollContainer>
      </LeftSideContainer>
  );

  if (!asColumn) {
    return content;
  }

  return <div className="col-md-3">{content}</div>;
}
